import { IOpenShiftEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateSlotsOpenShift", function updateSlotsOpenShift(slots: number) {
    if (shiftEditorViewState().isOpenShift) {
        const shift = shiftEditorViewState().openShift as IOpenShiftEntity;
        shift.openSlots = slots;
    }
});